module.exports = __webpack_public_path__ + "static/media/scooter.d9842e6a.png";